import Navigation from "@/components/site/Navigation";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import Services from "@/components/site/Services";
import Industries from "@/components/site/Industries";
import Technology from "@/components/site/Technology";
import About from "@/components/site/About";
import Certifications from "@/components/site/Certifications";
import Gallery from "@/components/site/Gallery";
import ClientStories from "@/components/site/ClientStories";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

export default function HomePage() {
  return (
    <main data-testid="landing-page" className="bg-ink-50">
      <Navigation />
      <Hero />
      <Marquee />
      <Services />
      <Industries />
      <Technology variant="dark" />
      <About />
      <Certifications />
      <Gallery />
      <ClientStories />
      <Contact />
      <Footer />
    </main>
  );
}
